import { createSelector } from '@reduxjs/toolkit';
import { getControlUnitById } from '.';
import { getSetPoints } from '../api/util/setPoint/getSetPoints';
import { getMixedCurrentEventsFromId } from './events';
import { getCUParametersComposedFromControlUnit } from '../../CUParameters/selectors';
import {
  getControlUnitsSensorDataByControlUnitId,
  getSensorDataMetadataSelector,
} from './sensordata';

export const getSetPointSelectorById = createSelector(
  [getControlUnitById],
  (controlUnit) => {
    return controlUnit?.setpoints;
  }
);

export const getSetPointsSelectorById = createSelector(
  [
    getSetPointSelectorById,
    getMixedCurrentEventsFromId,
    getSensorDataMetadataSelector,
    getControlUnitsSensorDataByControlUnitId,
    getCUParametersComposedFromControlUnit,
  ],
  getSetPoints
);
